module.exports = __webpack_public_path__ + "static/media/react-node-express2.533f381c.PNG";